import React, { Component } from "react";
import { getDataArray } from "../../helpers/getGridData";
import ApiClient from "utils/ApiClient";

import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import Table from "../../Table";
import TableStore from "../../TableStore";
import SubsheetButtons from "./SubsheetButtons";
import { observer } from "mobx-react";
import { FaExpandArrowsAlt } from "react-icons/fa";
import { MdGridOn } from "react-icons/md";
import styled, { css } from "styled-components";
import { DIMENSIONS } from "utils/Dimensions";
import { handleSocketConnection } from "app/websocketManager/eventEmitter";

class SubsheetColumnEditor extends Component {
  constructor(props) {
    super(props);
    // var { rowData } = getDataArray(columns, data);
    this.state = {
      value: props.value,
      editorModal: false,
      context: { componentParent: this },
      rowData: [],
      columns: this.getColumns(),
    };
    this.handleDeleteOnRange = this.handleDeleteOnRange.bind(this);
    this.handleColumnConfigChange = this.handleColumnConfigChange.bind(this);
  }

  onGridReady = (params) => {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  };

  onRangeSelectionChanged = (event) => {
    window.removeEventListener("keydown", this.handleDeleteOnRange);
    window.addEventListener("keydown", this.handleDeleteOnRange);
  };

  handleDeleteOnRange(event) {
    var cellRanges = this.gridApi.getCellRanges();
    var rowData = this.state.rowData;
    if ([46].indexOf(event.keyCode) > -1) {
      this.gridApi.stopEditing();
      cellRanges.map((range) => {
        if (range?.startRow?.rowIndex && range?.endRow?.rowIndex) {
          var startRow = Math.min(
            range.startRow.rowIndex,
            range.endRow.rowIndex
          );
          var endRow = Math.max(range.startRow.rowIndex, range.endRow.rowIndex);
          for (var rowIndex = startRow; rowIndex <= endRow; rowIndex++) {
            range.columns.forEach((column) => {
              if (column.colDef.field !== "row_id") {
                rowData[rowIndex][column.colDef.field] = "";
              }
            });
          }
        }
        this.setState({ rowData: rowData });
        this.gridApi.refreshCells();
      });
    }
  }

  fetchData = async () => {
    const resp = await ApiClient.List.getColumnData({
      list_id: this.props.listId,
      row_id: this.props.data.row_id,
      column_id: this.props.colDef.cellRendererParams.columnId,
      is_web: 1,
    });
    const columns = this.props.colDef.cellRendererParams.listColumns;
    const { rowData } = getDataArray(columns, resp.data);

    this.setState({ rowData });
  };

  isPopup() {
    return false;
  }

  handleSave = () => {
    const data = this.store.getDataForSave();

    if (data.length > 0 || this.store.isSubsheetRecordsDeleted) {
      this.props.onChange(data);
      this.store.isSubsheetRecordsDeleted = false;
    }

    this.props.api.stopEditing();
    this.setState({ editorModal: false });
    try {
      const parentRowNode = window.appStore?.containerStore?.currentViewStore?.getRowNodeById(this.store?.parentRowId).node;
      if (parentRowNode) {
        const subsheetDataCountInParentRow = parentRowNode?.data?.['column_' + this.store?.parentColumnId].toString();
        let newRowsCount = 0;
        this.store?.newRows?.forEach(row => {
          if (row.row_id && row.row_id > 0) {
            newRowsCount += 1;
          }
        });
        const actualCount = this.store.allRowsData.length + newRowsCount;
        if (subsheetDataCountInParentRow !== actualCount.toString()) {
          parentRowNode.data['column_' + this.store?.parentColumnId] = actualCount.toString();
          window.appStore?.containerStore?.currentViewStore?.gridApi.redrawRows({rowNodes : [parentRowNode]});
        }
      }
    } catch (error) {
      console.log('Main sheet subsheet count updation error.');
    }
    handleSocketConnection(window.appStore.containerStore.listId);
    this.store.addColumnStore.appStore.currentVisibleListId = '';
  };

  handleDoubleClick = () => {
    this.setState({ editorModal: true });
    handleSocketConnection(this.store.listId);
    this.store.addColumnStore.appStore.currentVisibleListId = this.store.listId;
    if (!this.store.addColumnStore.appStore.containerStores[this.store.listId]) {
      this.store.addColumnStore.appStore.containerStores[this.store.listId] = {};
    }
    this.store.addColumnStore.appStore.containerStores[this.store.listId]["currentSubsheetStore"] = this.store;
  };

  handleColumnConfigChange = async (columnConfig, decimals) => {
    const prevHighlightState = columnConfig?.prevHighlightState ?? false;
    if (columnConfig.hasOwnProperty('prevHighlightState')) {
      delete columnConfig.prevHighlightState;
    }
    this.props.colDef.store.containerStore.handleSubsheetColumnConfigChange(
      columnConfig,
      this.getColumnId()
    );
    this.setState({ columns: [...this.getColumns()] });
    try {
      const columnOptions = JSON.parse(columnConfig.options);
      if(columnOptions[0].is_highlighted){
        if (!prevHighlightState || (prevHighlightState && (columnConfig.column_type_id == "22" || columnConfig.column_type_id == "5" || columnConfig.column_type_id == "17"))) {
          await this.store?.getDuplicateColumnsData?.({["column_" + columnConfig.id] : columnConfig.column_type_id}, columnConfig.list_id);
        }
        if (Object.keys(this.store?.duplicateColumnsData).length > 1 && !this.store?.isLazyLoadEnabled) {
          if ((columnConfig.column_type_id === "22" || columnConfig.column_type_id === "5" || columnConfig.column_type_id === "17") && (decimals || decimals == 0) && columnOptions[0].decimals !== decimals && columnOptions[0].decimals + decimals > 0) {
            this.store.isSubsheetRowsLoaded = false;
            this.store?.refreshData();
          }
          this.store?.redrawRefreshedRows();
        }
      }
      else if(!columnOptions[0].is_highlighted && this.store?.duplicateColumnsData["column_" + columnConfig.id + '_' + this.store.parentRowId]){
        delete this.store.duplicateColumnsData["column_" + columnConfig.id + '_' + this.store.parentRowId];
      }
    } catch (e) {
      console.log("Error", e);
    }
  };

  handleColumnDelete = async (columnId) => {
    await this.props.colDef.store.containerStore.handleSubsheetColumnDelete(
      columnId,
      this.getColumnId()
    );
    this.setState({ columns: [...this.getColumns()] });
    return true;
  };

  handleColumnDeleteViaSockets = async (columnId) => {
    const mainColId = this.getColumnId();
    let listColumns = this.props.colDef.store.listConfig.listData.find(col => col.id === mainColId)?.list_columns ?? [];
    const columnIdx = listColumns.findIndex((col) => col.id == columnId);
    if(columnIdx >= 0) {
      const columnName = listColumns[columnIdx]?.name ?? listColumns[columnIdx]?.alias_name;
      listColumns.splice(columnIdx, 1);
      this.setState({ columns: [...listColumns] });
      return columnName;
    }
    return "";
  };

  getColumnId() {
    return this.props.colDef.cellRendererParams.columnId;
  }

  getColumns() {
    const columnId = this.getColumnId();

    return this.props.colDef.store.containerStore.getSubsheetListColumns(
      columnId
    );
  }

  getIsTableReadOnly() {
    return !this.props.colDef.store.containerStore.permissions.canChangeSettings();
  }

  render() {
    const tableProps = {
      isSubsheet: true,
      columnId: this.getColumnId(),
      rowId: this.props.data.row_id,
      parentListId: this.props.colDef.cellRendererParams.listId,
      listId: this.props.colDef.cellRendererParams.columnOptions.sub_list_id,
      columns: this.state.columns,
      listName: this.props.colDef.cellRendererParams.columnRaw.name,
      // setStore: (store) => (this.store = store),
      parentRow: this.props.node.data,
      value: this.props.value,
      onColumnConfigChange: this.handleColumnConfigChange,
      handleColumnDelete: this.handleColumnDelete.bind(this),
      handleColumnDeleteViaSockets: this.handleColumnDeleteViaSockets.bind(this),
      isTableConfigReadOnly: this.getIsTableReadOnly(),
      themeColor: this.props.colDef.store.containerStore.appStore.packStore.themeColor || '',
    };
    this.store = this.store ?? new TableStore(tableProps);
    const rowHeight = this.props.node.rowHeight - 5;

    return (
      <SubsheetDiv
        ref="container"
        width={Number(this.props.colDef.width)}
        maxHeight={this.props.node.rowHeight - 8}
        onDoubleClick={this.handleDoubleClick}
      >
        {(this.props.data?.row_id != "+" && this.props.value != "+r0w") && (
        <>
          <SubsheetInnerDiv height={this.props.node.rowHeight - 8}>
            <div>{this.props.value ? this.props.value : "0"}</div>
          </SubsheetInnerDiv>
          <StyledGridIconDiv
            onClick={() => {
              this.setState({ editorModal: true });
              handleSocketConnection(this.store.listId);
              this.store.addColumnStore.appStore.currentVisibleListId = this.store.listId;
              if (!this.store.addColumnStore.appStore.containerStores[this.store.listId]) {
                this.store.addColumnStore.appStore.containerStores[this.store.listId] = {};
              }
              this.store.addColumnStore.appStore.containerStores[this.store.listId]["currentSubsheetStore"] = this.store;
            }}
          >
            <MdGridOn size={18} />
          </StyledGridIconDiv>
        </>
        )}
        <Dialog
          fullWidth={true}
          maxWidth={"lg"}
          open={this.state.editorModal}
          onClose={this.handleSave}
          aria-labelledby="form-dialog-title"
          disableEnforceFocus
        >
          <DialogContent>
            <SubsheetDialogDiv className="ag-theme-material-custom">
              <SubsheetButtons store={this.store}></SubsheetButtons>
              <SubsheetTableDiv>
                <Table {...tableProps} store={this.store} />
              </SubsheetTableDiv>
            </SubsheetDialogDiv>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleSave} color="primary">
              Done
            </Button>
          </DialogActions>
        </Dialog>
      </SubsheetDiv>
    );
  }
}

const SubsheetDiv = styled.div`
  display: grid;
  ${(props) =>
    props.width &&
    css`
      width: ${props.width}px;
      height: ${props.maxHeight}px;
    `};
`;

const SubsheetSpan = styled.span`
  ${(props) =>
    props.rowHeight &&
    css`
      height: ${props.rowHeight}px;
    `};
`;

const SubsheetInnerDiv = styled.div`
  overflow: hidden;
  max-width: 83%;
  display: flex;
  align-items: center;
  ${(props) =>
    props.height &&
    css`
      max-height: ${props.height}px;
    `};
`;

const StyledGridIconDiv = styled.div`
  position: absolute;
  right: 5px;
  top: 5px;
  cursor: pointer;
  line-height: normal;
  color: #237ff4;
  background-color: #fff;
  &:hover {
    background-color: #237ff4;
    color: #fff;
  }
`;

const SubsheetDialogDiv = styled.div`
  height: 80vh;
`;

const SubsheetTableDiv = styled.div`
  height: 73vh;
`;

export default observer(SubsheetColumnEditor);

export function SubsheetColumnRenderer(params) {
  return `<div
        style="line-height: ${
          params.node.rowHeight <= DIMENSIONS.cell_height_compact
            ? "normal"
            : ""
        };"
      >
        ${
          typeof params.value == "object"
            ? params.value?.length ?? "0"
            : params.value ?? "0"
        }
      </div>`;
}
